// export const Theme = {
//   colors: {
//     base1: "#1e464a", // deep green backgrounf [navbar, about , contact]
//     base2: "#fff", //white
//     primary: "#008B8B", //lighter green
//     primary1: "#2F4F4F", // deepest green [portfolio, footer]
//   },
// };


export const Theme = {
  colors: {
    base1: "#1D1D1D", // deep green backgrounf [navbar, about , contact]
    base2: "#fff", //white
    primary: "#008B8B", //lighter green
    primary1: "#1D1D1D", // deepest green [portfolio, footer]
  },
};